import { useTranslations } from "next-intl";

interface AboutValuesSectionProps {
    anchorId?: string;
}

export const AboutValuesSection: React.FC<AboutValuesSectionProps> = ({ anchorId }) => {
    const t = useTranslations("About.values");
    const items = t.raw("items") as Array<{
        title: string;
        description: string;
        icon: string;
    }>;

    return <div id={anchorId} className="w-full bg-[#EEEEEE] p-10 pb-24">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-10 md:mb-10">
                <span className="bg-gradient-to-r from-[#08264C] to-[#3F74EF] bg-clip-text text-transparent 
                    font-h1-up font-[number:var(--h1-up-font-weight)] text-[length:var(--h1-up-font-size)] tracking-[var(--h1-up-letter-spacing)] leading-[var(--h1-up-line-height)] [font-style:var(--h1-up-font-style)]
                    translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:200ms]">
                    {t("subtitle")}
                </span>
                <h2 className="max-w-[700px] mx-auto font-heading-h1 font-[number:var(--heading-h1-font-weight)] text-x-900 text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[length:var(--heading-h1-font-size)] tracking-[var(--heading-h1-letter-spacing)] leading-tight md:leading-tight lg:leading-[var(--heading-h1-line-height)] [font-style:var(--heading-h1-font-style)]
                            translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:400ms]">
                    {t("title")}
                </h2>
            </div>
            <div className="bg-white rounded-[100px] p-8 w-full flex justify-center flex-wrap gap-x-[10px] gap-y-[30px]
                            translate-y-[-1rem] animate-fade-in opacity-0 [--animation-delay:400ms]">
                {items.map((item, index) => (
                <div
                    key={index}
                    className="
                    basis-[240px] flex flex-col items-center text-center
                    opacity-0 translate-y-[1rem] animate-fade-in
                    "
                    style={{
                    animationDelay: `${500 + index * 150}ms`
                    }}
                >
                    <img
                    className="mb-5 w-[85px] h-auto object-contain transition-all duration-500 hover:scale-105"
                    alt={`${item.title} icon`}
                    src={item.icon}
                    />

                    <div className="px-5">
                    <span className="font-heading-h4 font-[number:var(--heading-h4-font-weight)] 
                        text-x-900 text-[length:var(--heading-h4-font-size)] 
                        tracking-[var(--heading-h4-letter-spacing)] 
                        leading-[var(--heading-h4-line-height)] 
                        [font-style:var(--heading-h4-font-style)]">
                        {item.title}
                    </span>

                    <p className="mt-4 font-body-m font-[number:var(--body-m-font-weight)] 
                        text-x-800 text-sm md:text-base tracking-[var(--body-m-letter-spacing)] 
                        leading-[var(--body-m-line-height)] [font-style:var(--body-m-font-style)]">
                        {item.description}
                    </p>
                    </div>
                </div>
                ))}
            </div>            
        </div>

    </div>
}

